import React from "react";
import ReactDOM from "react-dom";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { IntlProvider } from "react-intl";

import "@treelab/panda/build/dist/index.css";

import "./index.css";
import { localeMessages } from "./lib/internationalization";
import Test from "./components/Test";
import { getQuery } from "./utils/app";
import { setCookie } from "./lib/cookies";
import ViewPage from "./pages/ViewPage";
import EditPage from "./pages/EditPage";

import reportWebVitals from "./reportWebVitals";

// 直接获取路由参数 整理成 props 后向下传递
const query = getQuery();

const defaultLocale = query.locale;

// 需要的参数 workspaceId tableId local 实例id（blockId） 是否有数据表权限(hasPermission) token
// 将 token 配置进 axios

setCookie("locale", query.locale);

ReactDOM.render(
  <IntlProvider locale={defaultLocale} messages={localeMessages[defaultLocale]} textComponent="span">
    <BrowserRouter>
      <Switch>
        <Route path={`/`} exact component={Test} />
        {/* <Route path={`/chart/view`} render={(props) => <ViewPage {...props} query={getQuery()} />} />
        <Route path={`/chart/edit`} render={(props) => <EditPage {...props} query={getQuery()} />} />
        <Route path={`/aggregate/view`} render={(props) => <ViewPage {...props} query={getQuery()} />} />
        <Route path={`/aggregate/edit`} render={(props) => <EditPage {...props} query={getQuery()} />} /> */}
        <Route path={`/:appType/edit`} render={(props) => <EditPage {...props} query={getQuery()} />} />
        <Route path={`/:appType/view`} render={(props) => <ViewPage {...props} query={getQuery()} />} />
      </Switch>
    </BrowserRouter>
  </IntlProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
